import { render, staticRenderFns } from "./searchCert.vue?vue&type=template&id=7a55d39d&scoped=true"
import script from "./searchCert.vue?vue&type=script&lang=js"
export * from "./searchCert.vue?vue&type=script&lang=js"
import style0 from "./searchCert.vue?vue&type=style&index=0&id=7a55d39d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55d39d",
  null
  
)

export default component.exports